import type { LngLat } from '@/backend/market/models/LngLat'
import type { ServiceMiniEntity } from '@/features/service/domain/entities/ServiceMiniEntity'
import type { MealTiersMiniEntity } from '@/features/mealTiers/domain/entities/MealTiersMiniEntity'

export class CompaniesEntity {
  createdAt?: string
  updatedAt?: string
  deletedAt?: string | null
  id?: number
  name?: string | null
  logoUrl?: string | null
  location?: LngLat
  service?: ServiceMiniEntity
  mealTier?: MealTiersMiniEntity
  timeBeforeMealLocksInMinute?: number
  startingMealTimeInMinute?: number
  maxItemPerUserPerMeal?: number
  disabled?: boolean
}
